export default __webpack_public_path__ + "img/318d96a317efcfff3684680f22819068.svg";